import { render } from "./TagList_old.vue?vue&type=template&id=1e8e21b0&scoped=true"
import script from "./TagList_old.vue?vue&type=script&lang=js"
export * from "./TagList_old.vue?vue&type=script&lang=js"

import "./TagList_old.vue?vue&type=style&index=0&id=1e8e21b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8e21b0"]])

export default __exports__